<template>
  <div
    class="ab-test-wrapper"
    :class="cssClass"
  >
    <div class="component-a">
      <slot name="component_a" />
    </div>

    <div class="component-b">
      <slot name="component_b" />
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'AbTestWrapper'
})

defineProps({
  cssClass: {
    type: String,
    default: ''
  }
})
</script>

<style scoped>
.ab-test-wrapper .component-a,
.ab-test-wrapper .component-b {
  display: none;
}

.ab-test-wrapper.show-a .component-a {
  display: block;
}
.ab-test-wrapper.show-a .component-b {
  display: none;
}

.ab-test-wrapper.show-b .component-a {
  display: none;
}
.ab-test-wrapper.show-b .component-b {
  display: block;
}
</style>
